<template>
  <div class="generate-options d-sm-flex align-items-sm-center justify-content-sm-center">
    <div class="form-inline mr-md-1">
      <label class="text-light my-1 mx-md-1" for="itemName">
        <strong>Nome do artefato:</strong>
      </label>
      <input
        class="form-control mx-md-1 my-1"
        type="text"
        id="itemName"
        v-model="itemName"
      />
    </div>
    <button
      class="btn text-left construct-artifact"
      :class="constructButtonClasses"
      type="button"
      @click="generateArtifact"
      :disabled="isCalculatingZoom"
    >
      <i class="ra ra-fairy-wand mr-2"></i>
      <strong v-if="item.uuid">Reconstruir artefato</strong>
      <strong v-else>Criar artefato</strong>
    </button>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'

  import { PREVIEW } from '../store/modules'

  export default {
    name: 'ItemName',
    computed: {
      ...mapState([ 'item' ]),
      ...mapState(PREVIEW, [ 'isCalculatingZoom' ]),
      ...mapFields({
        itemName: 'item.name'
      }),
      constructButtonClasses() {
        return {
          'btn-secondary': !this.item.uuid,
          'btn-success': !!this.item.uuid
        }
      },
    },
    methods: {
      generateArtifact() {
        this.$emit('generate')
      }
    }
  }
</script>